import { getPlainContent, truncate } from 'flarum/common/utils/string';
export const networks = {
  facebook: '//facebook.com/sharer/sharer.php?u={url}',
  twitter: '//twitter.com/intent/tweet?url={url}&text={title}',
  linkedin: '//linkedin.com/sharing/share-offsite/?url={url}',
  reddit: '//www.reddit.com/submit?url={url}&title={title}',
  whatsapp: '//api.whatsapp.com/send/?phone&text={title}%20{url}',
  telegram: '//telegram.me/share/url?url={url}&text={title}',
  vkontakte: '//vk.com/share.php?url={url}&title={title}&description={description}',
  odnoklassniki: '//connect.ok.ru/offer?url={url}',
  my_mail: '//connect.mail.ru/share?url={url}&title={title}&description={description}',
  qq: '//connect.qq.com/widget/shareqq/iframe_index.html?url={url}&title={title}',
  qzone: '//sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={url}&summary={description}&title={title}',
  // Dismissing the share sheet rejects with an AbortError: the reader changed
  // their mind, which isn't a failure. Anything else still is.
  native: shareData => navigator.share(getNativeData(shareData)).catch(error => {
    if (error?.name !== 'AbortError') throw error;
  })
};
export const networkIcons = {
  twitter: 'fa-brands fa-x-twitter',
  vkontakte: 'fab fa-vk',
  my_mail: 'fas fa-at',
  qq: 'fab fa-qq',
  qzone: 'fas fa-star',
  native: 'fas fa-share-square'
};
export const getNetworkIcon = network => {
  return networkIcons[network] || `fab fa-${network}`;
};
export const data = discussion => {
  const url = discussion.shareUrl();
  const title = discussion.title();
  const firstPost = discussion.firstPost();
  const description = firstPost && truncate(getPlainContent(firstPost.contentHtml()), 150, 0) || '';
  return {
    url,
    title,
    description
  };
};
export const getNativeData = _ref => {
  let {
    title,
    description,
    url
  } = _ref;
  return {
    title,
    text: description,
    url
  };
};
export const canNativeShare = discussion => {
  return !!navigator.canShare?.(getNativeData(data(discussion)));
};
flarum.reg.add('fof-share-social', 'forum/util/share', { networks: networks,networkIcons: networkIcons,getNetworkIcon: getNetworkIcon,data: data,getNativeData: getNativeData,canNativeShare: canNativeShare, });